import { PersonnelAlarmCounterSVG } from "./PersonnelAlarmCounterSVG";
export default PersonnelAlarmCounterSVG;
